import React from 'react';

import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { Box, Card, ComposedElement, Skeleton, Typography } from '@bcp-nextgen-dx-component-factory/design-system';
import { rem } from '@helpers';
import { avatarLogoBcp } from '@icons';

export const DocCardSkeleton: React.FC = () => {
	const t = useTranslation();

	const resources = {
		descriptionSignDocCard: t('placeholders.millennium.documentContract'),
	};

	return (
		<div style={{ marginTop: rem(20) }}>
			<Card.Base width={'100%'}>
				<Box styles={{ flexGrow: 1, alignItems: 'center' }}>
					<Box
						styles={{
							flexShrink: 0,
							width: rem(48),
							height: rem(48),
							justifyContent: 'center',
							alignItems: 'center',
						}}
					>
						<ComposedElement
							icon={{ source: avatarLogoBcp, svgProps: { width: rem(48), height: rem(48) } }}
						/>
					</Box>
					<Box styles={{ flexGrow: 1, margin: '0 16px' }}>
						{/* <Skeleton variant={'light'} layout={[{ width: 447, height: 20.8, borderRadius: 8 }]} /> */}
						<Typography appearance="body-100-03">{resources.descriptionSignDocCard}</Typography>
					</Box>
					<Box styles={{ flexGrow: 0 }}>
						<Skeleton variant={'light'} width={120} height={34} borderRadius={100} />
					</Box>
				</Box>
			</Card.Base>
		</div>
	);
};
